var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExplorationEducator(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#585858"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M41.721 3.7c.718 0 1.3.582 1.3 1.3 0 .673-.511 1.227-1.167 1.293l-.133.007H39.3L39.3 28c0 1.823-1.477 3.3-3.3 3.3H23.66v4.744l-.002.047 7.232 3.221c.655.293.95 1.061.658 1.717-.292.656-1.06.95-1.716.659l-7.652-3.409-7.651 3.409c-.656.292-1.424-.003-1.717-.66-.273-.614-.031-1.328.54-1.655l.12-.06 7.513-3.35c.023-.029.048-.057.074-.084l.001-4.579H9c-1.823 0-3.3-1.477-3.3-3.3L5.699 6.3H3c-.673 0-1.227-.512-1.293-1.167L1.7 5c0-.673.512-1.227 1.167-1.293L3 3.7h38.721zM36.7 6.3H8.3V28c0 .387.313.7.7.7h27c.387 0 .7-.313.7-.7V6.3zM24.721 18.7c.718 0 1.3.582 1.3 1.3 0 .673-.511 1.227-1.167 1.293l-.133.007H14c-.718 0-1.3-.582-1.3-1.3 0-.673.512-1.227 1.167-1.293L14 18.7h10.721zm6-6.5c.718 0 1.3.582 1.3 1.3 0 .673-.511 1.227-1.167 1.293l-.133.007H14c-.718 0-1.3-.582-1.3-1.3 0-.673.512-1.227 1.167-1.293L14 12.2h16.721z",
    transform: "translate(-698 -518) translate(522 501) translate(176 17)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplorationEducator);
export default __webpack_public_path__ + "static/media/exploration-educator.43e3c0e8.svg";
export { ForwardRef as ReactComponent };